import { Form, Field } from 'react-final-form';
import React, { forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from 'ncoded-component-library';
import InputField from 'components/InputField';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import validate from 'validations';
import useRenameFile from '../../../hooks/useRenameFile';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import classNames from 'classnames';

import './RenameModal.styles.scss';

type RenameModalProps = {
  className?: string;
  node: DataRoomNode;
};

const RenameModal: React.ForwardRefRenderFunction<
  ModalRef,
  RenameModalProps
> = ({ node, className }, ref) => {
  const [modal, modalRef] = useCallbackRef<ModalRef>(null);

  const { t } = useTranslation();

  useImperativeHandle(ref, () => modal, [modal]);

  const { _id, name } = node;

  const onRenameFile = useRenameFile({
    id: _id,
    onRenameSuccess: () => modal?.close(),
  });

  const classes = classNames('data-room-document-rename-modal', className);

  return (
    <Modal className={classes} ref={modalRef} title={t('rename')}>
      <Form
        initialValues={{ name }}
        onSubmit={onRenameFile}
        render={({ handleSubmit, submitting, pristine }) => (
          <form onSubmit={handleSubmit}>
            <Field
              label={t('newName')}
              name="name"
              component={InputField}
              validate={validate.required()}
              required
            />

            <div className="actions">
              <Button variant="link" onClick={modal?.close}>
                {t('cancel')}
              </Button>
              <Button type="submit" disabled={pristine || submitting}>
                {t('rename')}
              </Button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};

export default forwardRef(RenameModal);
